var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return 1 < _vm.pages
    ? _c("nav", { staticClass: "pagination-nav" }, [
        1 < _vm.pages
          ? _c(
              "ul",
              { staticClass: "pagination" },
              [
                _c(
                  "li",
                  {
                    staticClass: "page-item",
                    class: { disabled: _vm._page == 1 }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link prev-link",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.prev }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.prevBtnText))])]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.pages <= _vm.max
                  ? [
                      _vm._l(_vm.pages, function(n) {
                        return [
                          _c(
                            "li",
                            {
                              staticClass: "page-item",
                              class: { active: _vm._page == n }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { href: _vm.deeplink },
                                  on: {
                                    click: function($event) {
                                      return _vm.goto(n, $event)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(n))])]
                              )
                            ]
                          )
                        ]
                      })
                    ]
                  : _vm._page <= _vm.max - 3
                  ? [
                      _vm._l(_vm.max - 2, function(n) {
                        return [
                          _c(
                            "li",
                            {
                              staticClass: "page-item",
                              class: { active: _vm._page == n }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { href: _vm.deeplink },
                                  on: {
                                    click: function($event) {
                                      return _vm.goto(n, $event)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(n))])]
                              )
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: _vm.deeplink },
                            on: {
                              click: function($event) {
                                return _vm.goto(_vm.pages, $event)
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.pages))])]
                        )
                      ])
                    ]
                  : _vm.pages - _vm.max + 3 < _vm._page
                  ? [
                      _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: _vm.deeplink },
                            on: {
                              click: function($event) {
                                return _vm.goto(1, $event)
                              }
                            }
                          },
                          [_c("span", [_vm._v("1")])]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._l(_vm.max - 2, function(n) {
                        return [
                          _c(
                            "li",
                            {
                              staticClass: "page-item",
                              class: { active: _vm._page == _vm.start + n }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { href: _vm.deeplink },
                                  on: {
                                    click: function($event) {
                                      _vm.goto(_vm.start + n, $event)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.start + n))])]
                              )
                            ]
                          )
                        ]
                      })
                    ]
                  : [
                      _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: _vm.deeplink },
                            on: {
                              click: function($event) {
                                return _vm.goto(1, $event)
                              }
                            }
                          },
                          [_c("span", [_vm._v("1")])]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _vm._l(_vm.max - 4, function(n) {
                        return [
                          _c(
                            "li",
                            {
                              staticClass: "page-item",
                              class: { active: _vm._page == _vm.start + n }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "page-link",
                                  attrs: { href: _vm.deeplink },
                                  on: {
                                    click: function($event) {
                                      _vm.goto(_vm.start + n, $event)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.start + n))])]
                              )
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: _vm.deeplink },
                            on: {
                              click: function($event) {
                                return _vm.goto(_vm.pages, $event)
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.pages))])]
                        )
                      ])
                    ],
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "page-item",
                    class: { disabled: _vm._page == _vm.pages }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link next-link",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.next }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.nextBtnText))])]
                    )
                  ]
                )
              ],
              2
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "page-item disabled" }, [
      _c("span", { staticClass: "page-link" }, [_vm._v("…")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "page-item disabled" }, [
      _c("span", { staticClass: "page-link" }, [_vm._v("…")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "page-item disabled" }, [
      _c("span", { staticClass: "page-link" }, [_vm._v("…")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "page-item disabled" }, [
      _c("span", { staticClass: "page-link" }, [_vm._v("…")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }